import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEYS } from '../config/constants';
// import { AsyncLocalStorage } from 'async_hooks';
import { JwtHelperService } from "@auth0/angular-jwt";
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService { //wrapper, could add more features, change storage, etc.

  constructor( ) { }

  save(key: string, value: string){
    localStorage.setItem(key, value);
  }
  get(key: string){
    return localStorage.getItem(key);
  }
  remove(key: string){
    localStorage.removeItem(key);
  }
  clear(){
    localStorage.clear();
  }
  length(){
    return localStorage.length;
  }
}